import App from "../website/App";
import CampaignPlanningConfirmation from "../website/sections/campaign-planning-confirmation/CampaignPlanningConfirmation";

window.App = App;
window.Section = CampaignPlanningConfirmation;
